module.exports = __webpack_public_path__ + "img/фон_мобильный-г.a3e6c624.jpg";